import React, { memo } from 'react';
import { object, string } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './NoResults.module.scss';
const cx = classNames.bind(styles);

const NoResults = ({ labels, searchWord }) => {
  const noResultsMsg = searchWord
    ? labels.searchNoResults
    : labels.autosuggestionNoResults;

  return (
    <div className={cx('root')}>
      <h2 className={cx('title')}>{noResultsMsg} </h2>
      {!!searchWord && (
        <div className={cx('text')}>
          "<span dangerouslySetInnerHTML={{ __html: searchWord }} />"
        </div>
      )}
    </div>
  );
};

NoResults.propTypes = {
  searchWord: string,
  labels: object.isRequired,
};

NoResults.defaultProps = {
  searchWord: null,
};

export default memo(withLabels(withErrorBoundary(NoResults)));



// WEBPACK FOOTER //
// ./src/components/NoResults/NoResults.js